export const darkTheme = {
  dark: true,
  colors: {
    primary: "#64b5f6",
    background: "#121212",
    border: "#676767",
    card: "rgb(18,18,18)",
    notification: "rgb(255, 69,58)",
    text: "#fff",
    error: "#D50000"
  }
};
export const lightTheme = {
  dark: false,
  colors: {
    primary: "#64b5f6",
    background: "#FFF",
    border: "rgb(216, 216, 216)",
    card: "rgb(255,255,255)",
    notification: "rgb(255, 59,48)",
    text: "#000",
    error: "#D50000"
  }
};

export const themes = {
  darkTheme,
  lightTheme
};
